module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/step3-818bc6fe111348a3eaeaa5b5650a20b8.svg";